import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import MessageGroup from "./MessageGroup";
import MessagesDetail from "./MessagesDetail";
import MessageContact from "./MessageContact";
import {
  deleteChatData,
  getChats,
  getConversation,
  groupMemberDelete,
  markAsRead,
  markAsReadAll,
  messageDelete,
  postChats,
} from "./MessageService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../App";
import { PostDate } from "../Dashboard/CommonComponents/PostDate";
import EmojiPicker from "emoji-picker-react";
import moment from "moment";
import {
  GetMasterTypeData,
  uploadDoc,
} from "../../../Services/Global-Services/GlobalServices";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Image } from "primereact/image";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import { useDispatch, useSelector } from "react-redux";
import { clearMessageRequestData } from "../../../Services/Redux/DataTransferToAnother";
import LoginLoader from "../../../Shared/Sidebar/LoginLoader";
const defaultImage = "/images/placeholder_profile.png";

const Messages = () => {
  const ApplyMessageRequestData = useSelector(
    (state) => state?.messageResult?.messageRequestData
  );
  const dispatch = useDispatch();
  const [Isloading, setIsloading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [visibleId, setVisibleId] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const [showMessagePage, setShowMessagePage] = useState(true);
  const [showContactPage, setShowContactPage] = useState(false);
  const [showMessageGroupPage, setShowMessageGroupPage] = useState(false);
  const [showMessageDetailsPage, setShowMessageDetailsPage] = useState(false);
  const [chatsData, setChatsData] = useState([]);
  const [chatsId, setChatsId] = useState({ chatsId: 0, groupId: 0 });
  const [conversationData, setConversationData] = useState([]);
  const toster = useContext(TostMsg);
  const [activeTab, setActiveTab] = useState(0);
  const [messageType, setMessageType] = useState(0);
  const [messageData, setMessageData] = useState("");
  const [mediaPreviewUrl, setMediaPreviewUrl] = useState(null);
  const [selectedEmpData, setSelectedEmpData] = useState([]);
  const isImage = (url) => /\.(jpeg|jpg|gif|png|webp)$/i.test(url);
  const isVideo = (url) => /\.(mp4|webm|ogg)$/i.test(url);
  const isPDF = (url) => /\.pdf$/i.test(url);
  const isExcel = (url) => /\.(xls|xlsx|xlsm|csv)$/i.test(url); // Excel files
  const isWord = (url) => /\.(doc|docx|dotx)$/i.test(url); // Word files
  const isFile = (url) => /\.(txt|rtf|ppt|pptx|odt|ods|odp)$/i.test(url);
  const isMediaURL = (url) =>
    isImage(url) ||
    isVideo(url) ||
    isPDF(url) ||
    isExcel(url) ||
    isWord(url) ||
    isFile(url);
  const [isVisibleEmoji, setisVisibleEmoji] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [currentGroup, setCurrentGroup] = useState([]);
  const [selectedGroupEditData, setSelectedGroupEditData] = useState([]);
  const [selectedGroupData, setSelectedGroupData] = useState([]);
  const [deleteContent, setDeleteContent] = useState([]);
  const [deleteGroupId, setDeleteGroupId] = useState([]);
  const [ExitGroupId, setExitGroupId] = useState([]);
  const [deleteChatId, setDeleteChatId] = useState([]);
  const messagesEndRef = useRef(null);
  const history = useHistory();
  const [noData, setNoData] = useState([]);
  const fileInputRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const pickerRef = useRef(null);

  useEffect(() => {
    function handleClickOutemoji(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setisVisibleEmoji(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutemoji);
    return () => {
      document.removeEventListener("mousedown", handleClickOutemoji);
    };
  }, []);

  useEffect(() => {
    if (ApplyMessageRequestData) {
      setShowMessagePage(true);
      setShowContactPage(false);
      setSelectedEmpData(ApplyMessageRequestData);
      setActiveTab(ApplyMessageRequestData[0]?.EmpId);
      setChatsId({ chatsId: ApplyMessageRequestData[0]?.EmpId, groupId: 0 });
      setSelectedGroupData(ApplyMessageRequestData[0]);
      getAllConversation(ApplyMessageRequestData[0]?.EmpId, 0);
    }
  }, [ApplyMessageRequestData]);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setDeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  const formatDate = (dateString) => {
    const now = moment();
    const givenDate = moment(dateString);
    const diffInDays = now.diff(givenDate, "days");

    if (diffInDays < 7) {
      return givenDate.format("dddd"); // e.g., "Thursday"
    } else {
      return givenDate.format("MMM DD YYYY"); // e.g., "Sep 23 2025"
    }
  };


  useEffect(() => {
    GetMasterSystemAlertList("No_conversations", 2);
    getUserChats();
    getMasterRequestClarificationData();
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (chatsId?.chatsId !== 0) {
      if (!ApplyMessageRequestData) {
        getAllConversation(chatsId?.chatsId, chatsId?.groupId);
      }
    }
  }, [chatsId]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => { }, [currentGroup]);

  const filteredChatsData = useMemo(() => {
    if (!debouncedSearchTerm) return chatsData;

    return chatsData
      .filter((chat) =>
        chat.FirstName.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
      .sort((a, b) => a.FirstName.localeCompare(b.FirstName));
  }, [debouncedSearchTerm, chatsData]);

  const handleClickOutside = (event) => {
    if (!event.target.closest(".dropdown")) {
      setVisibleId(null);
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const toggleDropdown = (id) => {
    setVisibleId((prevId) => (prevId === id ? null : id));
  };

  const onClickChangePage = () => {
    setShowContactPage(true);
    setShowMessagePage(false);
    setShowMessageGroupPage(false);
    setShowMessageDetailsPage(false);
  };

  const onClickChangePageGroup = () => {
    setShowMessageGroupPage(true);
    setShowMessagePage(false);
    setShowContactPage(false);
    setShowMessageDetailsPage(false);
  };

  const onClickChangePageGroupDetail = (chat) => {
    setCurrentGroup(chat);
    setShowMessageDetailsPage(true);
    setShowMessageGroupPage(false);
    setShowMessagePage(false);
    setShowContactPage(false);
  };

  const handleLastName = (page, selectedData) => {
    if (page == "contactType") {
      setShowMessagePage(true);
      setShowContactPage(false);
      if (selectedData) {
        setSelectedEmpData([selectedData]);
        setActiveTab(selectedData?.EmpId);
        setChatsId({ chatsId: selectedData?.EmpId, groupId: 0 });
        setSelectedGroupData(selectedData);
        getAllConversation(selectedData?.EmpId, 0);
      }
    } else if (page == "groupType") {
      setShowMessagePage(true);
      setShowMessageGroupPage(false);
      setShowContactPage(false);
      setShowMessageDetailsPage(false);
      setSelectedGroupEditData([]);
      getUserChats();
    } else if (page == "groupEdit") {
      setSelectedGroupEditData(selectedData);
      setShowMessageGroupPage(true);
      setShowMessagePage(false);
      setShowContactPage(false);
      setShowMessageDetailsPage(false);
    }
  };

  async function getAllConversation(id, groupId) {
    const params = {
      SelectedCustomerId: id,
      Customerid: userDetails?.EmpId,
      IsGroup: groupId,
    };
    try {
      const conversationData = await getConversation(params);
      const conversaionDataList = conversationData?.Data?.MessageGroups || [];
      setConversationData(conversaionDataList);
      if (conversaionDataList?.length != 0) {
        if (conversaionDataList && conversaionDataList.length > 0) {
          const lastGroup = conversaionDataList[conversaionDataList.length - 1]; // last group
          const lastMessageList = lastGroup?.MessageList;
          const lastMessage =
            lastMessageList && lastMessageList.length > 0
              ? lastMessageList[lastMessageList.length - 1]
              : null;
          if (lastMessage) {
            const compairId =
              lastMessage?.IsGroup == true
                ? lastMessage?.ToId
                : lastMessage?.FromId;
            let markData = chatsData.filter((item) => item?.Id === compairId);
            if (markData.length > 0) {
              if (markData[0].IsUnread == 1) {
                markAsReadchat(markData[0]);
              }
            }
          }
        }
      }
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }
  useEffect(() => {
    scrollToBottom();
  }, [conversationData]);

  async function getUserChats(chatId) {
    const params = {
      LoggedinUserId: userDetails?.EmpId,
    };
    try {
      let chatsData = await getChats(params);
      let uniqueChats = Array.from(
        new Map(chatsData?.Data?.map((item) => [item.Id, item])).values()
      );
      let filteredChats = uniqueChats.filter(
        (chat) => chat.Id !== userDetails?.EmpId
      );
      setChatsData(filteredChats);
      if (chatId) {
        setActiveTab(chatId);
      } else {
        setActiveTab(filteredChats[0]?.Id);
      }
      if (!ApplyMessageRequestData) {
        setSelectedGroupData(filteredChats[0]);
        setChatsId({
          chatsId: filteredChats[0]?.Id,
          groupId: filteredChats[0]?.IsGroup,
        });
      }
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  const handleTabClick = (index, chat) => {
    setMessageData("");
    setMediaPreviewUrl(null);
    setSelectedEmpData([]);
    setSelectedGroupData(chat);
    setActiveTab(chat.Id);
    setChatsId({ chatsId: chat.Id, groupId: chat?.IsGroup });
    setShowMessagePage(true);
    setShowContactPage(false);
    setShowMessageGroupPage(false);
    setShowMessageDetailsPage(false);
  };

  async function getMasterRequestClarificationData() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "MessageType",
    };
    try {
      const allMasterTypeData = await GetMasterTypeData(params);
      setMessageType(allMasterTypeData.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST.MasterDataType);
    }
  }

  const handleInputChange = (e) => {
    const value = e.target.value;
    setMessageData(value);
    if (isMediaURL(value)) {
      setMediaPreviewUrl(value);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const setMediaFromUpload = useCallback((url) => {
    if (isMediaURL(url)) {
      setMediaPreviewUrl(url);
    } else {
      setMessageData(url);
    }
  }, []);

  const handleSendMessage = async () => {
    let messageTypeFind = mediaPreviewUrl ? mediaPreviewUrl : messageData;
    determineMessageType(messageTypeFind);
    let messageTypeId = messageType.find(
      (value) =>
        value.Name.toUpperCase() ===
        determineMessageType(messageData).toUpperCase()
    );
    if (messageData.length <= 4000) {
      if (messageData || mediaPreviewUrl) {
        const params = {
          FromId: userDetails?.EmpId,
          ToId: chatsId?.chatsId,
          MessageTypeId: messageTypeId?.Id,
          Message: messageData,
          MessageMedia: mediaPreviewUrl ?? "",
          MessageMediaThumbnail: mediaPreviewUrl ?? "",
          ReferenceId: 0,
          GroupId: chatsId?.groupId == 1 ? chatsId?.chatsId : chatsId?.groupId,
        };
        try {
          await postChats(params);
          dispatch(clearMessageRequestData(null));
          getAllConversation(chatsId?.chatsId, chatsId?.groupId);
          if (selectedEmpData) {
            getUserChats();
          }
          setMessageData("");
          setMediaPreviewUrl(null);
        } catch (error) {
          if (error?.status == 400) {
            toster.current.error(
              "Your message exceeds the maximum length of 4000 characters. Please shorten it and try again"
            );
          } else {
            toster.current.error(ERROR_LIST.GetMessage);
          }
        }
      }
    } else {
      toster.current.error("Your message exceeds the maximum length of 4000 characters. Please shorten it and try again");
    }
  };

  const determineMessageType = (messageData) => {
    const imageExtensions = /\.(jpg|jpeg|png|gif|bmp)$/i;
    const pdfExtension = /\.pdf$/i;
    const videoExtensions = /\.(mp4|avi|mov|mkv)$/i;
    const ExcelExtensions = /\.(xls|xlsx|xlsm|csv)$/i;
    const WordExtensions = /\.(doc|docx|dotx)$/i;

    if (imageExtensions.test(mediaPreviewUrl)) {
      return "image";
    } else if (pdfExtension.test(mediaPreviewUrl)) {
      return "pdf";
    } else if (videoExtensions.test(mediaPreviewUrl)) {
      return "video";
    } else if (ExcelExtensions.test(mediaPreviewUrl)) {
      return "Excel File ";
    } else if (WordExtensions.test(mediaPreviewUrl)) {
      return "Word file";
    } else {
      return "text";
    }
  };

  const getFileName = (name) => {
    if (!name) return "";
    const url = name.split(":").slice(1).join(":"); // get everything after first ":"
    let fileName = url.split("\\").pop().split("/").pop();
    return fileName;
  };

  // Delete Group functions
  async function deleteGroupByAdmin() {
    if (deleteGroupId) {
      const params = {
        Id: deleteGroupId,
      };
      try {
        let articleList = await messageDelete(params);
        if (articleList) {
          getUserChats();
          document.getElementById("delete-ed").click();
          GetMasterSystemAlertList("Message_Group_delete", 0);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  async function markAsReadchat(chat) {
    let groupValue;
    if (chat?.IsGroup == 1) {
      groupValue = true;
    } else {
      groupValue = false;
    }
    const params = {
      SelectedUserId: userDetails?.EmpId,
      LastReadMessageId: chat?.LastMessageId,
      ReceiverId: chat?.Id,
      IsGroup: groupValue,
    };
    try {
      if (chat?.Id) {
        await markAsRead(params);
        getUserChats(chat?.Id);
      }
    } catch (error) { }
  }

  async function onClickChangeReadAll() {
    const params = {
      LoggedinUser: userDetails?.EmpId,
    };
    try {
      await markAsReadAll(params);
      // toster.current.success("Read all successfully");
      getUserChats();
    } catch (error) { }
  }

  async function deleteChat() {
    if (deleteChatId) {
      const params = {
        ToId: deleteChatId?.Id,
        IsGroup: deleteChatId?.IsGroup,
      };
      try {
        await deleteChatData(params);
        toster.current.success("Delete chat successfully");
        getUserChats();
      } catch (error) { }
    }
  }

  const handleFileImageChange = useCallback(async (event) => {
    const selectedFiles = event.target.files;
    if (!selectedFiles || selectedFiles.length === 0) return;
    // Immediately upload files without storing in state
    await uploadPolicyDocFile(selectedFiles);
    // Reset input so the same file can be selected again
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, []);

  async function uploadPolicyDocFile(file) {
    setIsloading(true);
    if (file) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.Message,
        RefId: 0,
      };
      try {
        setIsloading(true);
        const response = await uploadDoc(params, formData);
        const data = response;
        if (!data?.Data || data.Data.length === 0) {
          console.warn("No file URL returned from API");
        } else {
          const ImageURL = data?.Data;
          setMediaFromUpload(ImageURL[0]);
        }

        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.UploadFileMsgError);
      } finally {
      }
    } else {
      setIsloading(false);
      toster.current.warn("No file selected");
    }
  }

  let EmojiArr = [];
  const onEmojiClick = (emojiObject) => {
    let textId = document.getElementById("chat-input");
    const start = textId.selectionStart;
    const end = textId.selectionEnd;
    EmojiArr.push(...emojiObject.emoji);
    const netText =
      textId.value.slice(0, start) + EmojiArr[0] + textId.value.slice(start);
    textId.value = netText;
    const newCursorPosition = start + EmojiArr[0].length;
    textId.setSelectionRange(newCursorPosition, newCursorPosition);
    textId.focus();
    setMessageData(netText);
  };

  async function onClickExitGroup() {
    if (ExitGroupId) {
      const params = {
        GroupId: ExitGroupId,
        MemberId: userDetails?.EmpId,
      };
      try {
        await groupMemberDelete(params);
        toster.current.success("Exit group successfully");
        document.getElementById("exit-group").click();
        getUserChats();
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  const changeRoute = (data) => {
    if (data?.IsGroup == 1) {
      onClickChangePageGroupDetail(data);
    } else {
      history.push(`/Profile/${data.Guid}`);
    }
  };

  return (
    <>
      <div className="message-page">
        <div className="row align-items-start innertabs">
          <div className="col-md-3 pr-0">
            <div className="chat-list first">
              <div className="messages-header">
                <h3 className="no-mb">Messages</h3>
                <a onClick={() => setShowSearch(!showSearch)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-search"
                    style={{ color: "#a9a8a8", cursor: "pointer" }}
                  >
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                </a>
              </div>
              {showSearch && (
                <div className="search-div">
                  <input
                    type="text"
                    placeholder="Search.."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              )}
              <div className="is-new-conversation">
                <button
                  id="start-conversation"
                  className="button h-button is-primary is-raised is-rounded is-fullwidth"
                  fdprocessedid="dzsf1f"
                  title="Contact"
                  onClick={() => onClickChangePage()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-plus"
                  >
                    <line x1={12} y1={5} x2={12} y2={19} />
                    <line x1={5} y1={12} x2={19} y2={12} />
                  </svg>
                  <span>Contact</span>
                </button>
                <button
                  id="start-conversation"
                  className="button h-button is-primary is-raised is-rounded is-fullwidth"
                  fdprocessedid="dzsf1f"
                  title="Create Group"
                  onClick={() => onClickChangePageGroup()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-plus"
                  >
                    <line x1={12} y1={5} x2={12} y2={19} />
                    <line x1={5} y1={12} x2={19} y2={12} />
                  </svg>
                  <span>Group</span>
                </button>
                <button
                  id="start-conversation"
                  className={`button h-button is-primary is-raised is-rounded is-fullwidth ${chatsData.filter((item) => item.IsUnread === 1).length === 0
                    ? "disabled"
                    : ""
                    }`}
                  fdprocessedid="dzsf1f"
                  title="Mark All Read"
                  onClick={() => onClickChangeReadAll()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-check-square"
                  >
                    <polyline points="9 11 12 14 22 4" />
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                  </svg>
                  <span>Read All</span>
                </button>
              </div>
              <div
                className="nav nav-pills"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                {filteredChatsData?.map((chat, index) => (
                  <button
                    className={`nav-link ${activeTab === chat.Id ? "active" : ""
                      }`}
                    id={`v-pills-home-tab-${index}`}
                    data-bs-toggle="pill"
                    data-bs-target={`#v-pills-home-${index}`}
                    type="button"
                    role="tab"
                    aria-controls={`v-pills-home-${index}`}
                    aria-selected={activeTab === index ? "true" : "false"}
                    key={index}
                  >
                    <div
                      className="recent-user"
                      onClick={() => handleTabClick(index, chat)}
                    >
                      <div className="user-container">
                        <img
                          className="is-user"
                          src={chat?.ProfilePic || defaultImage}
                          onError={handleImageError}
                          data-demo-src="images/pro-img/6.png"
                          alt=""
                        />
                      </div>
                      <div className="recipient-meta">
                        <span>{chat?.FirstName.slice(0, 10)}</span>
                        <span>{chat?.Message.slice(0, 19)} {chat?.Message.length > 19 && "..."}</span>

                      </div>
                      {chat?.IsUnread == 1 && (
                        <span className="unreadcss"></span>
                      )}

                    </div>
                    <div className="d-flex align-items-center chat-time-data">
                      <span className="message-time">
                        <PostDate
                          LastCommentDate={chat?.MessageDateAndTime}
                        />
                      </span>
                      <div
                        className="dropdown is-spaced is-right is-neutral dropdown-trigger"
                        onClick={(e) => e.stopPropagation()}
                      >

                        <div>
                          <div
                            className="button"
                            onClick={() => {
                              toggleDropdown(chat.Id);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-more-vertical"
                            >
                              <circle cx={12} cy={12} r={1} />
                              <circle cx={12} cy={5} r={1} />
                              <circle cx={12} cy={19} r={1} />
                            </svg>
                          </div>
                        </div>
                        <div className="dropdown-menu" role="menu">
                          <div className="dropdown-content">
                            <a href="#" className="dropdown-item">
                              <div className="media">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-bookmark"
                                >
                                  <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                                </svg>
                                <div className="media-content">
                                  <h3>Bookmark</h3>
                                  <small>Add this post to your bookmarks.</small>
                                </div>
                              </div>
                            </a>
                            <a className="dropdown-item">
                              <div className="media">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-bell"
                                >
                                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                                </svg>
                                <div className="media-content">
                                  <h3>Notify me</h3>
                                  <small>Send me the updates.</small>
                                </div>
                              </div>
                            </a>
                            <hr className="dropdown-divider" />
                            <a href="#" className="dropdown-item">
                              <div className="media">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-flag"
                                >
                                  <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                                  <line x1={4} y1={22} x2={4} y2={15} />
                                </svg>
                                <div className="media-content">
                                  <h3>Flag</h3>
                                  <small>In case of inappropriate content.</small>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div
                          id="myDIV2"
                          style={{
                            display: visibleId === chat.Id ? "block" : "none",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {chat?.IsUnread == 1 && (
                            <a
                              className="dropdown-item"
                              onClick={() => markAsReadchat(chat)}
                            >
                              <div className="media">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-check-square"
                                >
                                  <polyline points="9 11 12 14 22 4" />
                                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                                </svg>
                                <div className="media-content">
                                  <h3>Mark Read</h3>
                                </div>
                              </div>
                            </a>
                          )}
                          {chat?.IsGroupMember === 0 && (
                            <a
                              className="dropdown-item"
                              // onClick={() => deleteChat(chat)}
                              data-bs-toggle="modal"
                              data-bs-target="#delete-chat"
                              title="Delete"
                              onClick={() => {
                                setDeleteChatId(chat);
                                GetMasterSystemAlertList(
                                  "Article_Delete_Confirmation",
                                  1
                                );
                              }}
                            >
                              <div className="media">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  fill="currentColor"
                                  className="bi bi-trash"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                  <path
                                    fillRule="evenodd"
                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                  />
                                </svg>
                                <div className="media-content">
                                  <h3>Delete Chat</h3>
                                </div>
                              </div>
                            </a>
                          )}
                          {chat?.OwnerId == userDetails?.EmpId && (
                            <a
                              className="dropdown-item"
                              data-bs-toggle="modal"
                              data-bs-target="#delete-ed"
                              title="Delete"
                              onClick={() => {
                                setDeleteGroupId(chat?.Id);
                                GetMasterSystemAlertList(
                                  "Article_Delete_Confirmation",
                                  1
                                );
                              }}
                            // onClick={() => deleteGroupByAdmin(chat)}
                            >
                              <div className="media">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  fill="currentColor"
                                  className="bi bi-trash"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                  <path
                                    fillRule="evenodd"
                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                  />
                                </svg>
                                <div className="media-content">
                                  <h3>Delete Group</h3>
                                </div>
                              </div>
                            </a>
                          )}
                          {chat?.IsGroup == 1 && (
                            <a
                              className="dropdown-item"
                              data-bs-toggle="modal"
                              data-bs-target="#report-img"
                              onClick={() => onClickChangePageGroupDetail(chat)}
                            >
                              <div className="media">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={16}
                                  height={16}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-info"
                                >
                                  <circle cx={12} cy={12} r={10} />
                                  <line x1={12} y1={16} x2={12} y2={12} />
                                  <line x1={12} y1={8} x2="12.01" y2={8} />
                                </svg>
                                <div className="media-content">
                                  <h3>Group Info</h3>
                                </div>
                              </div>
                            </a>
                          )}
                          {chat?.CanMemberLeave == true && (
                            <>
                              {chat.OwnerId !== userDetails?.EmpId && (
                                <>
                                  {chat.IsGroupMember !== 0 && (
                                    <a
                                      className="dropdown-item"
                                      data-bs-toggle="modal"
                                      data-bs-target="#exit-group"
                                      title="Exit"
                                      onClick={() => { setExitGroupId(chat?.Id); }}
                                    >
                                      <div className="media">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={16}
                                          height={16}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="feather feather-corner-up-left"
                                        >
                                          <polyline points="9 14 4 9 9 4" />
                                          <path d="M20 20v-7a4 4 0 0 0-4-4H4" />
                                        </svg>
                                        <div className="media-content">
                                          <h3>Exit Group</h3>
                                        </div>
                                      </div>
                                    </a>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                  </button>
                ))}
              </div>
            </div>
          </div>
          {showMessagePage && (
            <div className="col-md-9 pl-0">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                  tabIndex={0}
                >
                  {selectedGroupData && (
                    <div className="top-message-header">
                      <div className="recent-user">
                        <div
                          className="user-container"
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            className="is-user"
                            src={
                              selectedGroupData?.ProfilePic
                                ? selectedGroupData?.ProfilePic
                                : selectedGroupData?.ProfileImage || defaultImage
                            }
                            onError={handleImageError}
                            data-demo-src="images/pro-img/6.png"
                            alt=""
                            onClick={() => changeRoute(selectedGroupData)}
                          />
                        </div>
                        <div
                          className="recipient-meta"
                          onClick={() => changeRoute(selectedGroupData)}
                          style={{ cursor: "pointer" }}
                        >
                          <span>
                            {selectedGroupData?.FirstName
                              ? selectedGroupData?.FirstName
                              : selectedGroupData?.FullName}
                          </span>
                          {selectedGroupData?.MessageDateAndTime && (
                            <span>
                              <PostDate
                                LastCommentDate={
                                  selectedGroupData?.MessageDateAndTime
                                }
                              />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>)}
                  <div className="action-items">
                    <div
                      className={
                        conversationData[0]?.MessageList?.length > 0
                          ? "chat-body-wrap"
                          : ""
                      }
                    >
                      <ol
                        id="chat-body"
                        className={
                          conversationData[0]?.MessageList?.length > 0
                            ? "chat-body"
                            : ""
                        } //"chat-body"
                        data-conversation-body="conversation1"
                      >
                        {conversationData?.map((allMessage, index) => (
                          <>
                            {allMessage?.MessageDate && (
                              <li className="divider-container" key={index}>
                                <div className="divider">
                                  <span>
                                    {formatDate(allMessage?.MessageDate)}
                                  </span>
                                </div>
                              </li>
                            )}
                            {allMessage?.MessageList?.map((message, index) => (
                              <>
                                {message?.FromId !== userDetails?.EmpId && (
                                  <>
                                    {message?.MessageTypeId !== 101 && (
                                      <li
                                        className="other"
                                        key={index}
                                        ref={messagesEndRef}
                                      >
                                        <div
                                          className="avatar"
                                          title={message?.SenderFirstName}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <Link
                                            to={`/Profile/${message.SenderGuid}`}
                                          >
                                            <img
                                              src={
                                                message?.SenderProfilePic ||
                                                defaultImage
                                              }
                                              onError={handleImageError}
                                              draggable="false"
                                            />
                                          </Link>
                                        </div>
                                        <div className="msg">
                                          <div className="msg-inner">
                                            <Link
                                              to={`/Profile/${message.SenderGuid}`}
                                            >
                                              <b
                                                className="others-name"
                                                style={{ cursor: "pointer" }}
                                              >
                                                {message?.SenderFirstName}
                                              </b>
                                            </Link>

                                            {message?.MessageTypeId == 103 && (
                                              <div className="image">
                                                <Image
                                                  src={
                                                    message?.MessageMedia ||
                                                    defaultImage
                                                  }
                                                  onError={handleImageError}
                                                  alt="317"
                                                  width="100%"
                                                  style={{
                                                    borderRadius: "5px",
                                                  }}
                                                  preview
                                                />
                                                <p>{message?.Message}.</p>
                                              </div>
                                            )}
                                            {message?.MessageTypeId == 102 && (
                                              <p>{message?.Message}.</p>
                                            )}
                                            {message?.MessageTypeId ==
                                              10102 && (
                                                <>
                                                  <div
                                                    className="image"
                                                  >
                                                    <a
                                                      href={message?.MessageMedia}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      <img
                                                        src="/images/tickets/pdf.png"
                                                        alt="317"
                                                        style={{
                                                          borderRadius: "100%",
                                                          width: "30px",
                                                        }}
                                                      />
                                                      <p>
                                                        {getFileName(
                                                          message?.MessageMedia
                                                        )}
                                                        .
                                                      </p>
                                                    </a>
                                                  </div>
                                                  <p>{message?.Message}.</p>
                                                </>
                                              )}
                                            {message?.MessageTypeId ==
                                              10107 && (
                                                <>
                                                  <div
                                                    className="image"
                                                  >
                                                    <a
                                                      href={message?.MessageMedia}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      <img
                                                        src="/images/tickets/doc.png"
                                                        alt="317"
                                                        width="100%"
                                                        style={{
                                                          borderRadius: "100%",
                                                          width: "30px",
                                                        }}
                                                      />
                                                      <p>
                                                        {getFileName(
                                                          message?.MessageMedia
                                                        )}
                                                        .
                                                      </p>
                                                    </a>
                                                  </div>
                                                  <p>{message?.Message}.</p>
                                                </>
                                              )}
                                            {message?.MessageTypeId ==
                                              10108 && (
                                                <>
                                                  <div
                                                    className="image"
                                                  >
                                                    <a
                                                      href={message?.MessageMedia}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      <img
                                                        src="/images/excels.png"
                                                        alt="317"
                                                        style={{
                                                          borderRadius: "100%",
                                                          width: "30px",
                                                        }}
                                                      />
                                                      <p>
                                                        {getFileName(
                                                          message?.MessageMedia
                                                        )}
                                                        .
                                                      </p>
                                                    </a>
                                                  </div>
                                                  <p>{message?.Message}.</p>
                                                </>
                                              )}
                                            {message?.MessageTypeId === 10103 &&
                                              isVideo(
                                                message?.MessageMedia
                                              ) && (
                                                <>
                                                  <video
                                                    controls
                                                    src={message.MessageMedia}
                                                    style={{
                                                      maxWidth: "100%",
                                                      maxHeight: "200px",
                                                      borderRadius: "8px",
                                                    }}
                                                  />
                                                  <p>{message?.Message}.</p>
                                                </>
                                              )}
                                          </div>
                                          <time>
                                            {moment(
                                              message?.CreatedDate
                                            ).format("HH:mm A")}
                                          </time>
                                        </div>
                                      </li>
                                    )}
                                  </>
                                )}
                                {message?.FromId === userDetails?.EmpId && (
                                  <>
                                    {message?.MessageTypeId !== 101 && (
                                      <li
                                        className="self"
                                        key={index}
                                        ref={messagesEndRef}
                                      >
                                        <div
                                          className="avatar"
                                          title={message?.SenderFirstName}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <img
                                            src={
                                              message?.SenderProfilePic ||
                                              defaultImage
                                            }
                                            onError={handleImageError}
                                            draggable="false"
                                          />
                                        </div>
                                        <div className="msg">
                                          <div className="msg-inner">
                                            {message?.MessageTypeId == 103 && (
                                              <div className="image">
                                                <Image
                                                  src={
                                                    message?.MessageMedia ||
                                                    defaultImage
                                                  }
                                                  onError={handleImageError}
                                                  alt="317"
                                                  width="100%"
                                                  style={{
                                                    borderRadius: "5px",
                                                  }}
                                                  preview
                                                />
                                                <p>{message?.Message}.</p>
                                              </div>
                                            )}
                                            {message?.MessageTypeId == 102 && (
                                              <p style={{ marginTop: "4px" }}>
                                                {message?.Message}.
                                              </p>
                                            )}
                                            {message?.MessageTypeId ==
                                              10107 && (
                                                <>
                                                  <div
                                                    className="image"
                                                  >
                                                    <a
                                                      href={message?.MessageMedia}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      <img
                                                        src="/images/tickets/doc.png"
                                                        alt="317"
                                                        width="100%"
                                                        style={{
                                                          borderRadius: "100%",
                                                          width: "30px",
                                                        }}
                                                      />
                                                      <p>
                                                        {getFileName(
                                                          message?.MessageMedia
                                                        )}
                                                        .
                                                      </p>
                                                    </a>
                                                  </div>
                                                  <p>{message?.Message}.</p>
                                                </>
                                              )}
                                            {message?.MessageTypeId ==
                                              10108 && (
                                                <>
                                                  <div
                                                    className="image"
                                                  >
                                                    <a
                                                      href={message?.MessageMedia}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      <img
                                                        src="/images/excels.png"
                                                        alt="317"
                                                        style={{
                                                          borderRadius: "100%",
                                                          width: "30px",
                                                        }}
                                                      />
                                                      <p>
                                                        {getFileName(
                                                          message?.MessageMedia
                                                        )}
                                                        .
                                                      </p>
                                                    </a>
                                                  </div>
                                                  <p>{message?.Message}.</p>
                                                </>
                                              )}
                                            {message?.MessageTypeId ==
                                              10102 && (
                                                <>
                                                  <div
                                                    className="image"
                                                  >
                                                    <a
                                                      href={message?.MessageMedia}
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                    >
                                                      <img
                                                        src="/images/tickets/pdf.png"
                                                        alt="317"
                                                        style={{
                                                          borderRadius: "100%",
                                                          width: "30px",
                                                        }}
                                                      />
                                                      <p>
                                                        {getFileName(
                                                          message?.MessageMedia
                                                        )}
                                                        .
                                                      </p>
                                                    </a>
                                                  </div>
                                                  <p>{message?.Message}.</p>
                                                </>
                                              )}
                                            {message?.MessageTypeId === 10103 &&
                                              isVideo(
                                                message?.MessageMedia
                                              ) && (
                                                <>
                                                  <video
                                                    controls
                                                    src={message.MessageMedia}
                                                    style={{
                                                      maxWidth: "100%",
                                                      maxHeight: "200px",
                                                      borderRadius: "8px",
                                                    }}
                                                  />
                                                  <p>{message?.Message}.</p>
                                                </>
                                              )}
                                          </div>
                                          <time>
                                            {moment(
                                              message?.CreatedDate
                                            ).format("HH:mm A")}
                                          </time>
                                        </div>
                                      </li>
                                    )}
                                  </>
                                )}

                                {message?.MessageTypeId == 101 && (
                                  <li className="divider-container" key={index}>
                                    <div className="divider quote-divider">
                                      <span>
                                        {message?.Message.slice(0, 10)}
                                        <img
                                          src={
                                            message?.SenderProfilePic ||
                                            defaultImage
                                          }
                                          onError={handleImageError}
                                        />
                                        <b>{message?.SenderFirstName}</b>
                                      </span>
                                    </div>
                                  </li>
                                )}
                              </>
                            ))}
                          </>
                        ))}
                      </ol>
                    </div>
                    {conversationData.length === 0 ? (
                      <>
                        <div className="notfound">
                          <div className="start-chart-profile">
                            <img src="/images/no-data-found/message.png" />
                            <p>{noData}</p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {conversationData.length === 0 && (
                          <>
                            {selectedEmpData.length === 0 && (
                              <div
                                className="notfound"
                                style={{ background: "#f2f2f2" }}
                              >
                                <div className="start-chart-profile">
                                  <LazyImage
                                    alt={selectedGroupData?.FirstName}
                                    src={selectedGroupData?.ProfilePic}
                                    width="32"
                                    height="32"
                                  />
                                  <p>{selectedGroupData?.FirstName}</p>
                                  <span>
                                    Type your message below to begin your
                                    conversation.
                                  </span>
                                </div>
                              </div>
                            )}
                            {selectedEmpData.length > 0 && (
                              <div
                                className="notfound"
                                style={{ background: "#f2f2f2" }}
                              >
                                <div className="start-chart-profile">
                                  <LazyImage
                                    alt={selectedEmpData[0].FullName}
                                    src={selectedEmpData[0].ProfileImage}
                                    width="32"
                                    height="32"
                                  />

                                  <p>{selectedEmpData[0].FullName}</p>
                                  <span>
                                    Type your message below to begin your
                                    conversation
                                  </span>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                  {(selectedGroupData?.IsGroupMember === 1 ||
                    selectedGroupData?.IsGroup === 0 ||
                    selectedEmpData.length > 0 ||
                    mediaPreviewUrl) && (
                      <div className="message-field-wrapper side-collapsed">
                        <div className="attached-file">
                          {isImage(mediaPreviewUrl) && (
                            <img src={mediaPreviewUrl} alt="Preview" />
                          )}
                          {isVideo(mediaPreviewUrl) && (
                            <video
                              controls
                              src={mediaPreviewUrl}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100px",
                                borderRadius: "8px",
                              }}
                            />
                          )}
                          {isPDF(mediaPreviewUrl) && (
                            <div className="image">
                              <img
                                src="/images/tickets/pdf.png"
                                alt="317"
                                style={{ borderRadius: "100%", width: "100px" }}
                              />
                            </div>
                          )}
                          {isExcel(mediaPreviewUrl) && (
                            <div className="image">
                              <img
                                src="/images/excels.png"
                                alt="317"
                                style={{ borderRadius: "100%", width: "100px" }}
                              />
                            </div>
                          )}
                          {isWord(mediaPreviewUrl) && (
                            <div className="image">
                              <img
                                src="/images/tickets/doc.png"
                                alt="317"
                                style={{ borderRadius: "100%", width: "100px" }}
                              />
                            </div>
                          )}
                          {isFile(mediaPreviewUrl) && (
                            <div className="image">
                              <img
                                src="/images/tickets/doc.png"
                                alt="317"
                                style={{ borderRadius: "100%", width: "100px" }}
                              />
                            </div>
                          )}
                        </div>
                        <div className="control">
                          <img
                            src={userDetails?.ProfileImage || defaultImage}
                            onError={handleImageError}
                            className="message-userprofile"
                          />
                          <textarea
                            type="text"
                            cols="2"
                            rows="6"
                            id="chat-input"
                            className="input is-rounded"
                            value={messageData}
                            onKeyDown={handleKeyDown}
                            onChange={handleInputChange}
                            placeholder="Write a message up to 4000 characters and upload file upto 20 MB ..."
                            fdprocessedid="unesrf"
                          ></textarea>
                          <div className="icons emoji-icon" style={{ zIndex: 1 }}>
                            <div
                              className="inner-position-relative"
                              style={{
                                textAlign: "end",
                                cursor: "pointer",
                                position: "relative",
                              }}
                            >
                              <div>
                                <svg
                                  onClick={() =>
                                    setisVisibleEmoji(!isVisibleEmoji)
                                  }
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="currentColor"
                                  className="bi bi-emoji-smile"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                  <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5" />
                                </svg>
                              </div>
                              {isVisibleEmoji && (
                                <div ref={pickerRef}>
                                  <EmojiPicker onEmojiClick={onEmojiClick} />
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="file-upload">
                            <div
                              className="button"
                              style={{
                                textAlign: "end",
                                cursor: "pointer",
                                position: "relative",
                              }}
                            >
                              <label style={{ cursor: "pointer" }}>
                                <input
                                  ref={fileInputRef}
                                  type="file"
                                  accept="*/*"
                                  onChange={handleFileImageChange}
                                  style={{ display: "none" }}
                                />
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="feather feather-plus"
                                >
                                  <line x1="12" y1="5" x2="12" y2="19" />
                                  <line x1="5" y1="12" x2="19" y2="12" />
                                </svg>
                              </label>
                              <p className="loader-message message-loader">{Isloading ? <LoginLoader /> : ""}</p>
                            </div>
                          </div>
                          <div className="send-message">
                            <div
                              className="button h-button is-primary is-raised is-rounded"
                              onClick={handleSendMessage}
                            >
                              Send
                            </div>
                          </div>
                        </div>
                        <div className="typing-indicator">
                          <img src="assets/img/icons/typing.gif" alt="" />
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
          )}
          {showMessageGroupPage && (
            <MessageGroup
              currentPage={handleLastName}
              currentGroupEdit={selectedGroupEditData}
            />
          )}
          {showMessageDetailsPage && (
            <MessagesDetail
              currentPage={handleLastName}
              currentGroup={currentGroup}
            />
          )}
          {showContactPage && <MessageContact currentPage={handleLastName} />}
        </div>
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>{deleteContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteGroupByAdmin()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-chat">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure you want to delete this chat?</strong>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => deleteChat()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="exit-group">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure want to exit this group?</strong>
              {/* <p>Exit from group</p> */}
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => onClickExitGroup()}
              >
                Exit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Messages;
